declare global {
  interface Window {
    fbq: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue: unknown[][]
      loaded: boolean
      version: string
      push: (...args: unknown[]) => void
    }
    _fbq: typeof window.fbq
  }
}

const FB_PIXEL_ID = '931666150041202'
let initialized = false

export function initFbPixel(): void {
  if (initialized || typeof window === 'undefined') return

  if (window.fbq) {
    initialized = true
    return
  }

  const n: any = (window.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', FB_PIXEL_ID)
  initialized = true
}

export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Relaxo - Dormir Profundo',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
